export default __webpack_public_path__ + "static/media/logo.9771d9ed.svg";